import { createSlice, createAsyncThunk} from '@reduxjs/toolkit'

// Define a type for the slice state
interface TokenState {
    token: string,
    status: string,
    error: string,
}

// Define the initial state usiEng that type
const initialState: TokenState = {
    token: '',
    status: '',
    error: ''
}

export const getToken =  createAsyncThunk('getToken', async (_, {rejectWithValue} ) => {

    const response = await fetch(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}/t`, {
        method: 'GET',
        credentials: 'include',

    })

    if (response.ok) {
        return response.json()
    } else {
        let res = await response.json()
        return rejectWithValue(res)
    }
})


export const tokenSlice = createSlice(
	{
		name: 'token',
		initialState,
		reducers: {},
		extraReducers(builder) {
			builder
			// getToken
			.addCase(getToken.fulfilled, (state, action) => {
				state.status = 'succeeded'
				console.log("getToken : fulfilled")
				state.token = action?.payload?.t
			})
            .addCase(getToken.rejected, (state, action) => {
				console.log("getToken : rejected")
				state.status = 'failed'

                const payload = action.payload as {error: string}
                state.error = payload?.error
                
			})
		}
	}
)

export default tokenSlice.reducer
